import EvaluacionDisciplinaAdministrativaAdapter from '../adapters/EvaluacionDisciplinaAdministrativa.adapter'

export default class UpdateEvaluacionDisciplinaAdministrativaUseCase {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(evaluacion) {
    try {
      const dto = EvaluacionDisciplinaAdministrativaAdapter.toDto(evaluacion)
      await this.#repository.update(dto)
    } catch (error) {
      throw new Error(`Failed to execute UpdateEvaluacionDisciplinaAdministrativaUseCase: ${error.message}`)
    }
  }
}
